import React from 'react'
import Modal from '@material-ui/core/Modal'
import styles from './styles.module.css'
import TextField from '@material-ui/core/TextField'
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from '@material-ui/core/IconButton'
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import axios from 'axios'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Dialog from '@material-ui/core/Dialog';
import {connect} from 'react-redux';
import Images from './images/Images';
import {getCategory,getSeries,getParts,setShowSeries,setShowPart} from '../../../containers/app/actions'
import SelectComp from '../../utils/Select/SelectComp';
import {withRouter} from 'react-router-dom'
import SplitButton from '../../utils/SplitButton/SplitButton';
import SelectSearch from '../../utils/Selectsearch/SelectSearch';
import {setShowCategory} from '../../../containers/app/actions'
import { Tooltip } from '@material-ui/core';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import { imageBaseUrl } from '../../../config/keys';
import ImageUploader from 'react-images-upload';
import ConfirmAlert from "../../utils/ConfirmAlert/ConfirmAlert.js";
import { addProduct } from '../../Banner/Banner.api';
const ConfProduct = (props) => {
    const [formData,setFormData] = React.useState({
        productName: "",
        productCost: "", 
        status: "Active",
        weight: "",
        length: "",
        width: "",
        height: "",
        description: "", 
        productId: "",
        categories: "",
        series: "",  
        CnF: "",
        isBestSeller:"No",
        isNewArrival:"No",
        isEcomEnabled:"No",
        displayName:'',
        ecomPrice:0,
        colour :'',
        material_type:'',
        warranty_year :'',
        is_storage:'No',
        lift_type:'',
        productCategorySequenceOrder: 0,
        size:null,
        finish:null,
    });
    const [parts,setParts] = React.useState([{partId: "",partType: ""}]); 

    const [images,setImages] = React.useState([])

    const [loading,setLoading] = React.useState(false)
    const [warehouse,setWareHouse] = React.useState([])
    const [err,setErr] = React.useState({productName: false, productCost: false, weight: false, productId: false, categories: false, series: false,  CnF: false, dealerPrice: false, distributorPrice: false})
    const [partErr,setPartErr] = React.useState([{partId: false,partType: false}]);
    const [category,setCategory] = React.useState(props.category);
    const [series,setSeries] = React.useState(props.series);
    const [removeImages,setRemoveImages] = React.useState([]);
    const [uploadedImages,setUploadedImages] = React.useState([]);
    const [newImages,setNewImages] = React.useState([]);
    const handleSelectImage = (value) => {
        let arr = newImages;
        console.log('add image');
        console.log(value);
        value.map(val => {
            arr.push(val); 
        });
        setNewImages([...arr]);
    }
    const handleDeselectImage = (index) => {
        let arr = [...newImages];
        arr = arr.filter((val, i) => index !== i)
        setNewImages([...arr]);
    }
    const onRemoveImage = (index) => {
        // id key is having the index of original image
        console.log("Remove image id", index);
        let prevUploadedImages = [...images];
        prevUploadedImages.splice(index,1);
        // let existArray = [...removeImages];
        // existArray.push(imageObject);     
        // setRemoveImages([...existArray]);
        setImages([...prevUploadedImages]);
    };
    React.useEffect(() => {
        setCategory(props.category)
    },[props.category])

    React.useEffect(() => {
        setSeries(props.series)
    },[props.series])

    React.useEffect(() => {
        if(props.type == "EDIT") {
            let data = formData;
            data = {...data,...props.product,productId: props.product._id};

            if(props.product.categories) 
                data = {...data,categories: props.product.categories}

            if(props.product.series)
                data = {...data,series: props.product.series}

            if(props.product.warehouseId)
                data = {...data,warehouse: props.product.warehouseId}

            setFormData({...data});
            setParts(props.product.productParts);
            setImages([...props.product.productImage]);
            let allProductImages = [...props.product.productImage];
            if(allProductImages && allProductImages.length > 0) {
                console.log('all Images');
                let allImages = allProductImages.map((img,index) => ({ id: index, dataURL: imageBaseUrl+img.imgUrl }));
                console.log(allImages);
                setUploadedImages(allImages);
            }     
        } 
    },[props.product]);

    React.useEffect(() => {
        if(props.activeCategory ) {
            setFormData({...formData,categories: props.activeCategory})
        }
    },[props.activeCategory])

    React.useEffect(() => {
        if(props.activeSeries) {
            setFormData({...formData,series: props.activeSeries})
        }
    },[props.activeSeries])


    React.useEffect(() => {
        !props.category && props.getCategory(props.user._id)
        !props.parts && props.getParts(props.user._id) 
        !props.series && props.getSeries(props.user._id)

        axios({
            method: "post",
            url: "/getAllWarehouse", 
        }).then(res => {
            setWareHouse(res.data.data)   
        }).catch(err => {
            console.log(err)
        });
    },[])

    // PARTS

    const handlePartAdd = () => { 
        let arr = parts;
        let err = partErr;

        arr.push({partId: "",partType: ""});
        err.push({partId: false,partType: false});

        setParts([...arr]);
        setPartErr([...err])
    } 
    const handlePartDelete = (index) => { 
        let arr = parts;
        arr = arr.filter((val,i) => index !== i) 
        setParts([...arr]);
    } 
    const handlePartChange = (value,index) => {
        if(value) {
            let arr = parts;
            arr[index]["partId"] = value;
            setParts([...arr]);
            let weight = 0;
            arr.forEach(val => {
                props.parts && props.parts.forEach(part => {
                    if(part._id == val["partId"]._id) {
                        weight += parseInt(part.weight);
                    }
                })
            })

            setFormData({...formData,weight: weight})
        }
    }
    
    const handlePartTypeChange = (value,index) => {
        let arr = parts;
        arr[index]["partType"] = value;
        setParts([...arr]);
    }

    // IMAGE
    const handleAddImage = (url) => {
        let arr = images;
        arr.push({imgUrl: url}); 
        setImages([...arr]);
    }

    // const handleDeleteImage = (index) => {
    //     let arr = images;
    //     arr = arr.filter((val,i) => index != i) 
    //     setImages([...arr]);
    // }
    const validate = () => {
        let validData = true;
        let error = {productName: false, productCost: false, categories: false, series: false,  CnF: false}
        let prtErr = Array(parts.length).fill({partId: false,partType: false});
        setPartErr([...prtErr]);
        setErr({...err,...error});
        Object.keys(error).map(key => {
            console.log("error formData[key]");
            console.log(formData[key]);
            if(formData[key] == "") {
                error[key] = "Field cannot be empty";
                validData = false
            } 
        });

        parts.forEach((val,index) => { 
            if(val.partId == "") { 
                prtErr[index].partId = "Field cannot be empty"
                validData = false
            }
            if(val.partType == "") { 
                prtErr[index].partType = "Field cannot be empty"
                validData = false
            }
        });

        setErr({...error}); 
        setPartErr([...prtErr]);
        
        return validData;
    }

    // SUBMIT
    const onSubmit = () => {
        console.log(validate());

        if(validate()) {
            setLoading(true);
            const url = props.type == "EDIT" ? "/eaditProductApi" : "/addProductApi"
            let productParts = parts.map(val => {
                return {
                    partId: val.partId && val.partId._id,
                    partType: val.partId && val.partType
                }
            })
            let productImagesArray = [];
            if(props.type == "EDIT" && images && images.length > 0) {
                productImagesArray = images.map(val => {
                    return {
                        imgUrl: val.imgUrl,
                        thumbUrl: val.thumbUrl
                    }
                });
            }
            let requestData = new FormData();
            console.log(typeof(formData));
            // TODO:code below needs improvement
            Object.keys(formData).forEach(fieldName => {
                console.log(fieldName, formData[fieldName]);
                if(fieldName == 'distributorPrice' || fieldName == 'dealerPrice' || fieldName =='ecomPrice' || fieldName == 'categories' || fieldName == 'series' 
                || fieldName =='productParts' || fieldName == 'productCost'|| fieldName == 'productImage') {
                    console.log('Not appended:',fieldName+' = '+ formData[fieldName]);
                } else {
                    requestData.append(fieldName, formData[fieldName]);
                }
              });
            // for ( let [key,value] of formData ) {
            //     console.log('sss');
            //     console.log(key,value);
            //     requestData.append(key, value);
            // }
            console.log(images);
            for (var i = 0; i < newImages.length; i++) {
                console.log('iiii');
                console.log(newImages[i]);
                requestData.append('images['+i+']', newImages[i]);
            }
            console.log("formData.ecomPrice:",formData.ecomPrice);
            // requestData.append("removeImages", removeImages && removeImages ? JSON.stringify(removeImages):null);
            
            requestData.append("ecomPrice", formData.ecomPrice && formData.ecomPrice != null ? formData.ecomPrice:0);
            requestData.append("categories", formData.categories && formData.categories._id ? formData.categories._id:null);
            requestData.append("series", formData.series && formData.series._id ? formData.series._id:null);
            requestData.append("productParts", productParts && productParts.length > 0 ?JSON.stringify(productParts):[]);
            if(props.type == 'EDIT') {
                requestData.append("productImage", productImagesArray && productImagesArray.length > 0 ? JSON.stringify(productImagesArray):[]);
            }            
            // productImage: uploadedImages,
            console.log("formData.productCost:"+formData.productCost);
            requestData.append("productCost", formData.productCost && formData.productCost > 0 ? formData.productCost:0);
            requestData.append("dealerPrice", formData.productCost && formData.productCost > 0 ?formData.productCost:0);
            requestData.append("distributorPrice", formData.productCost && formData.productCost > 0 ?formData.productCost:0);
            console.log(...requestData);
            addProduct(props.type,requestData)
            .then(res => {
                console.log('response');
                console.log(res);
                if(res.success) {
                    setParts([]);
                    setImages([]);
                    setUploadedImages([]);
                    setNewImages([]);
                    setRemoveImages([]);
                    props.onDone();
                    setLoading(false);
                    props.setAlert("Succesfully Done");
                } else {
                    setLoading(false);
                    props.setAlert("Something went wrong !Try Again")
                }
            }).catch(err => {
                console.log(err)
                setLoading(false)
                props.setAlert("Something went wrong !Try Again")
            })
            // requestData.append("type", formData.type); 
            // axios({
            //     headers: {
            //         "Content-Type": "multipart/form-data",
            //       },
            //     method: "post",
            //     url: url,
            //     data: 
            //         ...formData,
            //         productParts: productParts, 
            //         productImage: uploadedImages,
            //         newImages:newImages,
            //         removeImages:removeImages,
            //         categories: formData.categories && formData.categories._id,
            //         series: formData.series && formData.series._id,
            //         dealerPrice: formData.productCost && formData.productCost,
            //         distributorPrice: formData.productCost && formData.productCost  
            // })
            // .then(res => {
            //     if(res.data.success) {
            //         setFormData({productName: "",productCost: "",productCode: "",productQuantity: "",status: "Active",
            //         weight: "",length: "",width: "",height: "", productId: "",categories: "",series: "",description:"",
            //         ecomPrice:"",isNewArrival:"No",isEcomEnabled:'No',isBestSeller:"No",displayName:'',
            //         colour :'',material_type:'',warranty_year :'',is_storage:'',lift_type:''})
            //         setParts([]);
            //         setImages([]);
            //         setUploadedImages([]);
            //         setNewImages([]);
            //         setRemoveImages([]);
            //         props.onDone();
            //         setLoading(false);
            //         props.setAlert("Succesfully Done")
            //     } else {
            //         setLoading(false);
            //         props.setAlert("Something went wrong !Try Again")
            //     }
            // }).catch(err => {
            //     console.log(err)
            //     props.setAlert("Something went wrong !Try Again")
            //     setLoading(false)
            // })
        }
    }

    let btnText = props.type == "EDIT" ? "Update Product" : "Add Product";
 
    let partsLables = [];
    let partsIds = [];
    props.parts && props.parts.forEach(val => {
        partsLables.push(val.partName)
        partsIds.push(val._id)
    });
      
    
    let newCategoryList = category ? category.filter(val => val.status == "Active") : []
    let newSeriesList = series ? series.filter(val => val.status == "Active") : []
    let newPartList = props.parts ? props.parts.filter(val => val.status == "Active") : []
    return (  
        <Dialog open={props.open} onClose={props.onClose} scroll={'paper'} maxWidth={'lg'} fullWidth={true}>
            <div className={styles.container}>
                <div className={styles.containerContent}>
                    
                    <div className={styles.header}>
                        <h1>{btnText}</h1>
                        <div className={styles.buttons}>
                            <SplitButton
                                options={
                                    [ 
                                        {name: "Category",onClick: () => props.history.push("/admin/categories")},
                                        {name: "Parts",onClick: () => props.history.push("/admin/parts")},
                                        {name: "Series",onClick: () => props.history.push("/admin/series")},
                                    ]
                                }
                                name={"EXPLORE"}
                                color="secondary"
                            />
                            
                            <IconButton onClick={props.onClose}>
                                <CloseRoundedIcon   />
                            </IconButton>
                        </div>
                    </div>

                    <h2>Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Product Name"
                                value={formData.productName}
                                onBlur={(e) => setFormData({...formData,productName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,productName: e.target.value})}
                                error={err.productName}
                                helperText={err.productName}
                            />

                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Product MRP"
                                type="text"
                                value={formData.productCost} 
                                onBlur={(e) => setFormData({...formData,productCost: e.target.value.replace(/\D/,'').trim()})}
                                onChange={(e) => {
                                    setFormData({...formData,productCost: e.target.value.replace(/\D/,'')})
                                }}
                                error={err.productCost}
                                helperText={err.productCost}
                            /> 
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Length"
                                type="number"
                                value={formData.length} 
                                onBlur={(e) => setFormData({...formData,length: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,length: e.target.value})}
                                error={err.length}
                                helperText={err.length}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Width"
                                type="number"
                                value={formData.width} 
                                onBlur={(e) => setFormData({...formData,width: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,width: e.target.value})}
                                error={err.width}
                                helperText={err.width}
                            />
                        </div>
                        <div className={styles.row}>
                        <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Height"
                                type="number"
                                value={formData.height} 
                                onBlur={(e) => setFormData({...formData,height: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,height: e.target.value})}
                                error={err.height}
                                helperText={err.height}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Weight"
                                disabled
                                type="number"
                                value={formData.weight} 
                                onBlur={(e) => setFormData({...formData,weight: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,weight: e.target.value})}

                                error={err.weight}
                                helperText={err.weight}
                            />
                        </div>

                        <div className={styles.row}>  
                            <SelectSearch
                                variant="outlined"
                                className={styles.textField}
                                label="Category"
                                value={formData.categories} 
                                onChange={(value) => setFormData({...formData,categories: value})}
                                options={newCategoryList}
                                keyCode="categoryName"
                                addIcon={true}
                                onAdd={() => props.setShowCategory(true)}
                                onAddName="Add New Category"
                                error={err.categories}
                                helperText={err.categories}
                            />  

                            <SelectSearch
                                variant="outlined"
                                className={styles.textField}
                                label="Series"
                                value={formData.series} 
                                onChange={(value) => setFormData({...formData,series: value})}
                                options={newSeriesList}
                                keyCode="seriesName"
                                addIcon={true}
                                onAdd={() => props.setShowSeries(true)}
                                onAddName="Add New Series"
                                error={err.series}
                                helperText={err.series}
                            />   
                        </div>

                        <div className={styles.row}> 
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Cnf"
                                type="text"
                                value={formData.CnF} 
                                onBlur={(e) => setFormData({...formData,CnF: e.target.value.replace(/\D/,'').trim()})}
                                onChange={(e) => {
                                    setFormData({...formData,CnF: e.target.value.replace(/\D/,'')})
                                }}
                                error={err.CnF}
                                helperText={err.CnF}
                            />
                            <SelectComp
                                value={formData.status}
                                onChange={(e) => setFormData({...formData,status: e.target.value})}
                                label="Status"
                                variant="outlined"
                                className={styles.textField}
                                values={["Active","Inactive"]}
                                options={["Active","Inactive"]}
                            /> 
                        </div> 
                    </div>
                    <h2>Ecommerce Details</h2>

                    <div className={styles.content}>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Product Display Name"
                                value={formData.displayName}
                                onBlur={(e) => setFormData({...formData,displayName: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,displayName: e.target.value})}
                                error={err.displayName}
                                helperText={err.displayName}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Ecommerce MRP"
                                type="text"
                                value={formData.ecomPrice} 
                                onBlur={(e) => setFormData({...formData,ecomPrice: e.target.value.replace(/\D/,'').trim()})}
                                onChange={(e) => {
                                    setFormData({...formData,ecomPrice: e.target.value.replace(/\D/,'')})
                                }}
                                error={err.ecomPrice}
                                helperText={err.ecomPrice}
                            />
                        </div>
                        <div className={styles.row}>
                            <SelectComp
                                value={formData.isBestSeller}
                                onChange={(e) => setFormData({...formData,isBestSeller: e.target.value})}
                                label="Set Best Seller"
                                variant="outlined"
                                className={styles.textField}
                                values={["Yes","No"]}
                                options={["Yes","No"]}
                            />
                            <SelectComp
                                value={formData.isNewArrival}
                                onChange={(e) => setFormData({...formData,isNewArrival: e.target.value})}
                                label="Set New Arrival"
                                variant="outlined"
                                className={styles.textField}
                                values={["Yes","No"]}
                                options={["Yes","No"]}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textFieldFull}
                                label="Description"
                                value={formData.description}
                                onBlur={(e) => setFormData({...formData,description: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,description: e.target.value})}
                                error={err.description}
                                helperText={err.description}
                            />
                            
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Colour"
                                value={formData.colour}
                                onBlur={(e) => setFormData({...formData,colour: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,colour: e.target.value})}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Material Type"
                                value={formData.material_type}
                                onBlur={(e) => setFormData({...formData,material_type: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,material_type: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Warranty (years)"
                                type="number"
                                value={formData.warranty_year}
                                onBlur={(e) => setFormData({...formData,warranty_year: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,warranty_year: e.target.value})}
                                
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Lift Type"
                                value={formData.lift_type}
                                onBlur={(e) => setFormData({...formData,lift_type: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,lift_type: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                            <SelectComp
                                value={formData.is_storage}
                                onChange={(e) => setFormData({...formData,is_storage: e.target.value})}
                                label="Set Storage"
                                variant="outlined"
                                className={styles.textField}
                                values={["Yes","No"]}
                                options={["Yes","No"]}
                            />
                            <SelectComp
                                value={formData.isEcomEnabled}
                                onChange={(e) => setFormData({...formData,isEcomEnabled: e.target.value})}
                                label="Set Enabled"
                                variant="outlined"
                                className={styles.textField}
                                values={["Yes","No"]}
                                options={["Yes","No"]}
                            />
                        </div>
                        <div className={styles.row}>
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Size"
                                value={formData.size}
                                onBlur={(e) => setFormData({...formData,size: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,size: e.target.value})}
                            />
                            <TextField 
                                variant="outlined"
                                className={styles.textField}
                                label="Finishing"
                                value={formData.finish}
                                onBlur={(e) => setFormData({...formData,finish: e.target.value.trim()})}
                                onChange={(e) => setFormData({...formData,finish: e.target.value})}
                            />
                        </div>
                        <div className={styles.row}>
                             <TextField
                                variant="outlined"
                                className={styles.textField}
                                label="Sequence Number"
                                value={formData.productCategorySequenceOrder}
                                type="number"
                                onChange={(e) => setFormData({...formData,productCategorySequenceOrder: e.target.value})}
                            />
                        </div>
                    </div>

                    <Divider />

                    <div className={styles.header}>
                        <h2>Parts</h2>
                        <div>
                            <Button color="secondary" variant="contained" onClick={() => props.setShowPart(true)}>Add New Part</Button>
                            <Tooltip title="Add Part">
                                <IconButton onClick={handlePartAdd}>
                                    <AddRoundedIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>

                    <div className={styles.partsRow}>
                        {parts.map((val,index) => {
                            return (
                                <div className={styles.partRow}>
                                    <SelectSearch
                                        variant="outlined"
                                        className={styles.partId}
                                        label={"Part" + (index + 1)}
                                        value={val.partId} 
                                        onChange={(value) => handlePartChange(value,index)}
                                        options={newPartList} 
                                        keyCode="partName"


                                        error={partErr[index] && partErr[index].partId}
                                        helperText={partErr[index] && partErr[index].partId}
                                    />   
                                    <TextField 
                                        variant="outlined"
                                        label="Part Type"
                                        className={styles.partType}
                                        value={val.partType}
                                        onChange={(e) => handlePartTypeChange(e.target.value,index)}

                                        error={partErr[index] && partErr[index].partType}
                                        helperText={partErr[index] && partErr[index].partType}
                                    />
                                    <IconButton onClick={() => handlePartDelete(index)}>
                                        <DeleteRoundedIcon />
                                    </IconButton>
                                </div>
                            ) 
                        })}
                    </div>
                    <div className={styles.row}>
                            
                            {props.type == "EDIT" &&
                                <h2 style={{paddingLeft:10}}>Uploaded Images
                                    <label>&nbsp;&nbsp;: {images.length <= 0 ? 'No images uploaded yet':images.length}</label>
                                </h2>
                            }
                            
                    </div>
                    <div className={styles.row}>
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridGap: 20,paddingRight:10,paddingLeft:10 }}>
                                { props.type == "EDIT" && images && images.map((item,index) => (
                                    <div id={index}>
                                    <img 
                                        style={{objectFit:'contain',width:'270px',maxHeight:'156px',height:'156px'}} 
                                        src={(imageBaseUrl + item.imgUrl)}
                                        alt="new"
                                        />
                                        <div style={{fontWeight:'bold',width:'270px',backgroundColor:'gray',paddingLeft:5}}>
                                            <h6 style={{margin:'2%'}}>
                                            <ConfirmAlert msg='Are you sure you want delete image ?' onClickEvent={() => onRemoveImage(index)}> 
                                                <IconButton>
                                                <DeleteRoundedIcon />
                                                </IconButton>
                                            </ConfirmAlert>
                                            Delete
                                            </h6>  
                                        </div>
                                    </div>
                                ))}
                            </div>
                    </div>
                    <div className={styles.row}>
                        <ImageUploader
                        withIcon={false}
                        withPreview={true}
                        label="Upload Images"
                        buttonText="Select and Upload images"
                        onChange={handleSelectImage}
                        deleteImage={handleDeselectImage}
                        imgExtension={[".jpg", ".jpeg",".png"]}
                        maxFileSize={5242880}
                        fileSizeError=" file size is must be less than 5 mb"
                        />
                    </div>
                    {/* <h2>Images</h2> */}
                    {/* <Images 
                        images={images}
                        onAddImage={(url) => handleAddImage(url)}
                        onDeleteImage={(index) => handleDeleteImage(index)}
                    />  */}


                    <div className={styles.footer}>
                        {loading 
                            ?
                        <Button variant="contained" color="secondary">
                            Loading....
                        </Button>
                            :
                        <Button variant="contained" color="secondary" onClick={onSubmit}>
                            {btnText}
                        </Button>}
                    </div>
                </div>
            </div>
        </Dialog>  
    )
}

const mapStateToProps = state => ({
    user: state.appReducer.user,
    category: state.appReducer.category,
    parts: state.appReducer.parts,
    series: state.appReducer.series,
    activeCategory: state.appReducer.activeCategory,
    activeSeries: state.appReducer.activeSeries
})
export default withRouter(connect(mapStateToProps,{getCategory,getSeries,getParts,setShowCategory,setShowSeries,setShowPart})(ConfProduct));